import { IRadioOption } from 'app/interfaces/IRadioOption';

export type supportedMongoDbTypes = 'cosmos' | 'native' | 'atlas';

export enum driverVersions {
    Recommended = 'Recommended',
    Legacy = 'Legacy',
    v2 = 'v2',
    v1 = 'v1'
}

export function driverVersionRecommendedOptions(disableLegacy: boolean): Array<IRadioOption<driverVersions>> {
    return [
        {
            label: stringResources.Recommended,
            value: driverVersions.Recommended
        },
        {
            label: stringResources.DriverOption_Legacy,
            value: driverVersions.Legacy,
            disabled: disableLegacy
        }
    ];
}

export const driverVersionVersionOptions: Array<IRadioOption<driverVersions>> = [
    {
        label: `2.0 (${stringResources.Recommended})`,
        value: driverVersions.v2
    },
    {
        label: '1.0',
        value: driverVersions.v1
    }
];

export const driverVersionPreviewVersionOptions: Array<IRadioOption<driverVersions>> = [
    {
        label: `2.0 (${stringResources.Preview})`,
        value: driverVersions.v2
    },
    {
        label: '1.0',
        value: driverVersions.v1
    }
];

export const driverVersionV1PreviewVersionOptions: Array<IRadioOption<driverVersions>> = [
    {
        label: `2.0 (${stringResources.Recommended})`,
        value: driverVersions.v2
    },
    {
        label: `1.0 (${stringResources.Preview})`,
        value: driverVersions.v1
    }
];